<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title">{{ grs.standard.id > 0 ? "Edit" : "Add New" }} Standard</mat-card-title>
  </mat-card-header>
  <div class="mat-card-wrapper" style="background-color: #f3f3f3">
    <mat-card-content class="mcd-card-content" style="background-color: #f3f3f3; margin-bottom: 20px">
      <div class="mcd-edit-form mcd-grbes-form">
        <div style="margin: auto">
          <div style="
              background-color: #ffffff;
              border-radius: 8px;
              border: 1px solid #a0a0a04d;
              padding: 0 0 20px 0;
            ">
            <div>
              <div style="
                  font-size: 15px;
                  font-weight: 650;

                  color: #4d5258;
                ">
                <p style="padding: 16px 24px; margin: 0">
                  {{
                  selectedStandardType
                  ? selectedStandardType
                  : "Which type of standard would you like to Add ?"
                  }}
                </p>
                <hr style="
                    color: #a0a0a04d;
                    opacity: 1;
                    font-weight: 700;
                    margin: 0;
                  " />
              </div>
              <div>
                <app-stepper [steps]="formSteps"></app-stepper>
              </div>

              <div class="col-12" style="margin: auto">
                <mat-stepper (selectionChange)="onStepChange($event)" [selectedIndex]="currentStepIndex" linear
                  labelPosition="bottom" #stepper style="margin-bottom: 10px">
                  <form [formGroup]="addGrsForm">
                    <mat-step [stepControl]="step0Group">
                      <ng-template matStepLabel style="color: #4d5258; font-weight: bold">Standard Type</ng-template>

                      <div style="
                          display: grid;
                          grid-template-columns: repeat(2, 1fr);
                          gap: 24px;
                          margin: auto;
                        " class="col-9">
                        <div *ngFor="let item of visibleStandardTypes">
                          <div style="padding: 20px" class="card">
                            <span class="nav-icon gbs" *ngIf="item.name == 'Global Building Standards'"></span>
                            <span class="nav-icon os" *ngIf="item.name == 'Operations Standards'"></span>

                            <span class="nav-icon GAS" *ngIf="item.name == 'Global Approved Solution'"></span>

                            <span class="nav-icon Group" *ngIf="item.name == 'BU Standards'"></span>

                            <h3 style="
                                font-size: 16px;
                                font-weight: 900;
                                color: #4d5258;
                                text-align: left;
                              ">
                              {{ item.name }}
                            </h3>
                            <p style="
                                color: #696f77;
                                margin-bottom: 10px;
                                font-size: 13px;
                              ">
                              {{ item.description}}
                            </p>
                            <p style="color: #696f77; font-size: 11px">
                              <!-- {{ item.description?.split('.')?.[1] }} -->
                            </p>
                            <button mat-raised-button style="
                                width: fit-content;
                                background-color: #3f51b51a;
                                color: #3f51b5;
                                font-weight: 600;
                              " (click)="
                                handleStandardSelection(
                                  item.name,
                                  item.id,
                                  stepper
                                );
                                onChangeStandardType(item.id)
                              ">
                              {{ grs.standard.id > 0 ? "Edit" : "Add" }}
                              {{ item.name }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </mat-step>

                    <mat-step [stepControl]="step1Group">
                      <ng-template matStepLabel>Category and Location</ng-template>
                      <div class="col-9" style="margin: auto">
                        <div>
                          <div *ngIf="
                              globalstandards || !grs.standard.standardTypeId
                            ">
                            <label for="operationsCategory" style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Title*
                              <span matTooltip="Provide a clear, concise title for your Global Minimum Standard" style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <div class="title">
                              <input [ngStyle]="{
                                  'margin-bottom':
                                    addGrsForm.get('title')?.touched &&
                                    addGrsForm
                                      .get('title')
                                      ?.hasError('required')
                                      ? '0px'
                                      : '20px',
                                }" name="title" formControlName="title" required placeholder="Enter Title"
                                (paste)="onPasteCleanup('title')" class="form-title" />
                              <mat-error *ngIf="
                                  step1Group.get('title')?.touched &&
                                  step1Group.get('title')?.hasError('required')
                                ">
                                Title is required
                              </mat-error>
                            </div>

                            <!-- <mat-form-field>
                            <input
                              matInput
                              name="Title"
                              formControlName="title"
                              required
                              (paste)="onPasteCleanup('title')"
                            />
                            <mat-error
                              *ngIf="
                                addGrsForm.get('title').touched &&
                                addGrsForm.get('title').hasError('required')
                              "
                            >
                              Title is required
                            </mat-error>
                          </mat-form-field> -->
                          </div>

                          <div class="col-12" *ngIf="
                              !globalstandards && grs.standard.standardTypeId
                            ">
                            <label for="operationsCategory" style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Title*
                              <span matTooltip="Provide a clear, concise title for your Global Minimum Standard" style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <div class="title">
                              <input [ngStyle]="{
                                  'margin-bottom':
                                    addGrsForm.get('title')?.touched &&
                                    addGrsForm
                                      .get('title')
                                      ?.hasError('required')
                                      ? '0px'
                                      : '20px',
                                }" name="title" formControlName="title" required placeholder="Enter Title"
                                (paste)="onPasteCleanup('title')" class="form-title" />
                              <mat-error *ngIf="
                                  addGrsForm.get('title').touched &&
                                  addGrsForm.get('title').hasError('required')
                                ">
                                Title is required
                              </mat-error>
                            </div>
                            <!-- <mat-form-field>
                            <input
                              matInput
                              name="Titlea"
                              formControlName="title"
                              required
                              (paste)="onPasteCleanup('title')"
                            />
                            <mat-error
                              *ngIf="
                                addGrsForm.get('title').touched &&
                                addGrsForm.get('title').hasError('required')
                              "
                            >
                              Title is required
                            </mat-error>
                          </mat-form-field> -->
                          </div>
                        </div>

                        <div *ngIf="
                            addGrsForm['controls'].standardTypeId.value ==
                              standardTypeEnum.GlobalMinimumRestaurantStandard ||
                            selectedStandardType == 'Global Building Standards'
                          " [ngStyle]="{
                            'margin-bottom':
                              addGrsForm.get('categoryId')?.touched &&
                              addGrsForm.get('categoryId')?.hasError('required')
                                ? '45px'
                                : '70px',
                          }">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Category*
                            <span matTooltip="Please share the appropriate category for your standard" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span>
                          </label>
                          <div class="category-dropdown-wrapper">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step1Group.get('categoryId')?.invalid &&
                                  step1Group.get('categoryId')?.touched,
                              }" class="dropdown-list" [placeholder]="" [settings]="categorydropdownSettings"
                              [data]="categoryDropdownList" [(ngModel)]="selectedCategory"
                              (onSelect)="onCategorySelect($event)" (onDeSelect)="onCategoryDeSelect($event)"
                              [ngModelOptions]="{ standalone: true }">
                            </ng-multiselect-dropdown>
                          </div>

                          <!-- <mat-form-field>
                          <mat-select
                            formControlName="categoryId"
                            name="dropCategory"
                            [disabled]="grs.standard.id > 0"
                            [value]="addGrsForm['controls'].categoryId.value"
                            #category
                            (selectionChange)="setCategory(category)"
                            required
                          >
                            <mat-option
                              [value]="item.id"
                              *ngFor="let item of buildingCategories"
                            >
                              {{ item.name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field> -->
                        </div>
                        <div *ngIf="
                            addGrsForm['controls'].standardTypeId.value ==
                              standardTypeEnum.GlobalMinimumRestaurantStandard ||
                            selectedStandardType == 'Global Building Standards'
                          ">
                          <mat-error *ngIf="
                              addGrsForm.get('categoryId').touched &&
                              addGrsForm.get('categoryId').hasError('required')
                            " style="font-size: x-small; margin-bottom: 20px">
                            Category is required
                          </mat-error>
                        </div>

                        <div *ngIf="
                            addGrsForm['controls'].standardTypeId.value ==
                              standardTypeEnum.OperationsStandards ||
                            selectedStandardType == 'Operations Standards'
                          " [ngStyle]="{
                            'margin-bottom':
                              addGrsForm.get('categoryId')?.touched &&
                              addGrsForm.get('categoryId')?.hasError('required')
                                ? '45px'
                                : '70px',
                          }">
                          <label for="category" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Category*
                            <span matTooltip="Please share the appropriate category for your standard" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <div class="category-dropdown-wrapper">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step1Group.get('categoryId')?.invalid &&
                                  step1Group.get('categoryId')?.touched,
                              }" [placeholder]="" [settings]="categorydropdownSettings" [data]="categoryDropdownList"
                              [(ngModel)]="selectedCategory" (onSelect)="onCategorySelect($event)"
                              (onDeSelect)="onCategoryDeSelect($event)" [ngModelOptions]="{ standalone: true }">
                            </ng-multiselect-dropdown>
                          </div>

                          <!-- <mat-form-field>
                       
                          <mat-select
                            name="dropCategory"
                            [disabled]="grs.standard.id > 0"
                            [value]="addGrsForm['controls'].categoryId.value"
                            #category
                            (selectionChange)="setCategory(category)"
                            required
                          >
                            <mat-option
                              [value]="item.id"
                              *ngFor="let item of operationsCategories"
                            >
                              {{ item.name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field> -->
                        </div>
                        <div *ngIf="
                            addGrsForm['controls'].standardTypeId.value ==
                              standardTypeEnum.OperationsStandards ||
                            selectedStandardType == 'Operations Standards'
                          ">
                          <mat-error *ngIf="
                              addGrsForm.get('categoryId').touched &&
                              addGrsForm.get('categoryId').hasError('required')
                            " style="font-size: x-small; margin-bottom: 20px">
                            Category is required
                          </mat-error>
                        </div>

                        <div [ngStyle]="{
                            'margin-bottom':
                              addGrsForm.get('locationTypeId')?.touched &&
                              addGrsForm
                                .get('locationTypeId')
                                ?.hasError('required')
                                ? '45px'
                                : '70px',
                          }" *ngIf="globalstandards">
                          <div style="
                              display: flex;
                              justify-content: space-between;
                            ">
                            <label for="operationsCategory" style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Location*
                              <span
                                matTooltip="Please share where this standard may apply (physical space/location) at the Restaurant "
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <button *ngIf="selectedLocations.length > 1" style="
                                background: transparent;
                                border: none;
                                background-color: white;
                                color: #de3428;
                              " (click)="clearAllSelected()">
                              clear all
                            </button>
                          </div>

                          <!-- <mat-form-field *ngIf="globalstandards">
                        <mat-select
                          name="dropLocation"
                          [disabled]="grs.standard.id > 0"
                          [value]="addGrsForm['controls'].locationTypeId.value"
                          #location
                          (selectionChange)="
                            setLocationCategoryMapping(location)
                          "
                          required
                          multiple
                          [ngClass]="selectedOPtion"
                        >
                          <mat-option
                            [value]="item.id"
                            *ngFor="let item of locationTypes"
                          >
                            {{ item.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field> -->
                          <div style="max-height: 545px" class="multiLocations">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step1Group.get('locationTypeId')?.invalid &&
                                  step1Group.get('locationTypeId')?.touched,
                              }" #locationDropdown class="dropdown-list" [placeholder]=""
                              [(ngModel)]="selectedLocations" [settings]="dropdownSettings"
                              [data]="LocationsdropdownList" (onSelect)="onItemSelect($event)"
                              (onDeSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)"
                              [ngModelOptions]="{ standalone: true }" (onDropDownOpen)="onDropdownOpen()">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div>
                          <mat-error *ngIf="
                              addGrsForm.get('locationTypeId').touched &&
                              addGrsForm
                                .get('locationTypeId')
                                .hasError('required')
                            " style="font-size: x-small; margin-bottom: 20px">
                            Location is required
                          </mat-error>
                        </div>

                        <div *ngIf="showSublocationField()" [ngStyle]="{
                            'margin-bottom':
                              addGrsForm.get('subLocationTypeId')?.touched &&
                              addGrsForm
                                .get('subLocationTypeId')
                                ?.hasError('required')
                                ? '45px'
                                : '70px',
                          }">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Sub-Location*
                            <span matTooltip="Please provide further detail on where this standard applies " style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <div class="category-dropdown-wrapper">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step1Group.get('subLocationTypeId')
                                    ?.invalid &&
                                  step1Group.get('subLocationTypeId')?.touched,
                              }" class="dropdown-list" [(ngModel)]="subLocationselected" [placeholder]=""
                              [settings]="subLocationdropdownSettings" [data]="sublocationDropdownList"
                              (onSelect)="onSubLocationSelect($event)"
                              (onDeSelect)="onSubLocationDeSelect($event)"
                              [ngModelOptions]="{ standalone: true }">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div>
                          <mat-error *ngIf="
                              addGrsForm.get('subLocationTypeId').touched &&
                              addGrsForm
                                .get('subLocationTypeId')
                                .hasError('required')
                            " style="font-size: x-small; margin-bottom: 20px">
                            Sub-Location is required
                          </mat-error>
                        </div>

                        <div style="display: flex; justify-content: space-between" class="dates newForm">
                          <div style="width: 48%">
                            <label style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">New Restaurant Effective Date*
                              <span
                                matTooltip="Provide date the Global Minimum Standard takes effect for NEW STORE OPENINGS (NSO). Any newly built restaurants opened after this day will be subject to meeting the standard. Any restaurants unable to comply after this date will be subject to requesting an exception via the GRS Governance Board."
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <mat-form-field>
                              <input matInput [matDatepicker]="picker2" formControlName="newRestaurantEffectiveFrom" />
                              <mat-datepicker-toggle matSuffix [for]="picker2">
                                <img matDatepickerToggleIcon src="../../assets/images/date-calender.svg" alt="Calendar"
                                  style="
                                    width: 20px;
                                    height: 20px;
                                    cursor: pointer;
                                    margin-bottom: 2px;
                                  " /></mat-datepicker-toggle>
                              <mat-datepicker #picker2 style="height: 30px; width: 30px"></mat-datepicker>
                              <mat-error *ngIf="
                                  addGrsForm.get('newRestaurantEffectiveFrom')
                                    .touched &&
                                  addGrsForm
                                    .get('newRestaurantEffectiveFrom')
                                    .hasError('required')
                                ">
                                Date is required
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div style="width: 48%">
                            <label style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Existing Restaurant Effective Date*
                              <span
                                matTooltip="Provide date the Global Minimum Standard takes effect for existing McDonald's restaurants. Restaurants who do not meet this standard after the specified date will be required to request an exception via the GRS Governance Board."
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <mat-form-field>
                              <input matInput [matDatepicker]="picker" formControlName="effectiveFrom" />
                              <mat-datepicker-toggle matSuffix [for]="picker">
                                <img matDatepickerToggleIcon src="../../assets/images/date-calender.svg" alt="Calendar"
                                  style="
                                    width: 20px;
                                    height: 20px;
                                    cursor: pointer;
                                    margin-bottom: 2px;
                                  " /></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                              <mat-error *ngIf="
                                  addGrsForm.get('effectiveFrom').touched &&
                                  addGrsForm
                                    .get('effectiveFrom')
                                    .hasError('required')
                                ">
                                Date is required
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>

                        <div style="margin-top: 14px">
                          <button matButton matStepperPrevious (click)="previousStep()" style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;
                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                          </button>
                          <button (click)="nextStep()" matButton matStepperNext style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;

                              background-color: #ffffff;
                            ">
                            Next<img src="/assets/images/rightarrow.svg" alt="arrow" style="margin-left: 5px" />
                          </button>
                        </div>
                      </div>
                    </mat-step>

                    <mat-step [stepControl]="step2Group">
                      <ng-template matStepLabel>Basic Info</ng-template>

                      <div style="margin: auto" class="col-9">
                        <div *ngIf="
                            (!globalstandards &&
                              addGrsForm['controls'].standardTypeId.value) ||
                            selectedStandardType ==
                              'Global Approved Solution' ||
                            selectedStandardType == 'BU Standards'
                          ">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Search for a Dependant Minimum / Operations
                            Standard with Title or Description*
                            <span matTooltip="Info about the action" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>

                          <!-- new search filed for dependent -->
                          <div class="search-wrapper" #dropdownContainer>
                            <div class="search-box" [ngStyle]="{
                                'margin-bottom':
                                  addGrsForm.get('minimumStandadId')?.touched &&
                                  addGrsForm.get('minimumStandadId')?.hasError('required')
                                    ? '0px'
                                    : '30px'
                              }">
                              <div class="input-container" [class.dependent-standard-invalid]="
                                  addGrsForm.get('minimumStandadId')?.touched &&
                                  addGrsForm.get('minimumStandadId')?.hasError('required')
                                " (click)="toggleDropdown()">
                                <div class="selected-chips">
                                  <div *ngFor="
                                      let item of selectFromDepenedentStandard
                                    " class="chip-badge">
                                    <span>{{ item.title }}</span>
                                    <button (click)="removeItem(item); $event.stopPropagation()" class="chip-close">
                                      ×
                                    </button>
                                  </div>
                                </div>
                                <input *ngIf="
                                    selectFromDepenedentStandard.length === 0
                                  " #dependentInput type="text" class="search-field" placeholder="{{
                                    selectFromDepenedentStandard.length > 0
                                      ? ''
                                      : 'Select'
                                  }}" readonly />
                                <div style="
                                    top: 10px;
                                    right: 20px;
                                    position: absolute;
                                  ">
                                  <img src="../../assets/images/priority-low 1.svg" alt="enter logo" />
                                </div>
                              </div>

                              <div #dropdown *ngIf="showDependentDropdown" class="dropdown-wrapper">
                                <div class="input-container2">
                                  <input #searchInput matInputAutofocus type="text" class="search-field"
                                    placeholder="Search" [formControl]="minimumStandadControl" required autofocus
                                    (input)="
                                      onSearchInputChange($event.target.value)
                                    " />

                                  <button *ngIf="minimumStandadControl.value" style="background: none; border: none"
                                    (click)="
                                      clearSearch(); $event.stopPropagation()
                                    ">
                                    <img src="../../assets/images/cross-button.svg" alt="enter logo" />
                                  </button>
                                </div>
                                <div class="dropdown-results">
                                  <div *ngIf="!searched" style="
                                      display: flex;
                                      flex-direction: column;
                                      justify-content: center;
                                      align-items: center;
                                      height: 300px;
                                      text-align: center;
                                    ">
                                    <img src="../../assets/images/keyboard.svg" alt="enter logo" />
                                    <p style="
                                        font-weight: 300;
                                        margin-top: 10px;
                                        color: #3c3c3c;
                                        font-size: 13px;
                                      ">
                                      Start typing to search for Standard
                                    </p>
                                  </div>

                                  <div *ngIf="
                                      searched &&
                                      !minimumStandardsLoading &&
                                      minimumStandads.length === 0
                                    " style="
                                      display: flex;
                                      flex-direction: column;
                                      justify-content: center;
                                      align-items: center;
                                      height: 300px;
                                      text-align: center;
                                    ">
                                    <img src="../../assets/images/not-found.svg" alt="enter logo" />
                                    <p style="
                                        margin-top: 5px;
                                        margin-bottom: 0;
                                        color: #3c3c3c;
                                        font-size: 15px;
                                      ">
                                      No results found
                                    </p>

                                    <p style="
                                        margin-top: 10px;
                                        color: #3c3c3c;
                                        font-size: 12px;
                                      ">
                                      We couldn't find a Standard Name matching
                                      your search.
                                    </p>
                                  </div>

                                  <div *ngIf="minimumStandardsLoading">
                                    <div style="
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        height: 300px;
                                        text-align: center;
                                      ">
                                      <mat-spinner [diameter]="40"></mat-spinner>
                                    </div>
                                  </div>

                                  <div *ngIf="minimumStandads.length > 0">
                                    <div *ngFor="let result of minimumStandads" class="result-option"
                                      (click)="selectDependentrow(result)">
                                      <mat-checkbox style="margin-right: 5px" [checked]="isSelected(result)"
                                        (click)="$event.stopPropagation()" (change)="
                                          selectItem($event.checked, result)
                                        ">
                                      </mat-checkbox>
                                      {{ result.title }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- new search field end here  -->

                          <app-inline-loader *ngIf="minimumStandadsLoading" class="inline-loader"></app-inline-loader>
                          <mat-error *ngIf="
                              addGrsForm.get('minimumStandadId')?.touched &&
                              addGrsForm.get('minimumStandadId')?.hasError('required')
                            " style="font-size: x-small; margin-bottom: 20px">
                            Dependant Standard is required
                          </mat-error>
                        </div>

                        <div class="newForm">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Description for New Restaurants*
                            <span
                              matTooltip="Provide 1-2 sentences describing requirements for NEW build restaurants (NSO) per the Global Minimum Standard. For example - 'All Restaurants are required to install provide hands-free faucets at kitchen handwashing stations'"
                              style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <div class="description">
                            <textarea placeholder="Enter new Restaurant Description" class="textarea" [ngStyle]="{
                                'margin-bottom':
                                  addGrsForm.get('newrestaurantdescription')
                                    ?.touched &&
                                  addGrsForm
                                    .get('newrestaurantdescription')
                                    ?.hasError('required')
                                    ? '0px'
                                    : '10px',
                              }" style="height: 120px" matInput name="description"
                              formControlName="newrestaurantdescription" required (paste)="
                                onPasteCleanup('newrestaurantdescription')
                              "></textarea>

                            <mat-error *ngIf="
                                addGrsForm.get('newrestaurantdescription')
                                  .touched &&
                                addGrsForm
                                  .get('newrestaurantdescription')
                                  .hasError('required')
                              ">
                              Description is required
                            </mat-error>
                          </div>
                          <!-- <mat-form-field>
                           
                          </mat-form-field> -->
                        </div>

                        <mat-checkbox (change)="copyDescriptionToExisting($event.checked)"
                          style="margin-bottom: 20px; color: #595a6c">
                          Use same description for existing restaurants too.
                        </mat-checkbox>

                        <div class="newForm">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Description for Existing Restaurants*
                            <span
                              matTooltip="Provide 1-2 sentences describing requirements for existing restautants. For example - 'All Restaurants are required to install provide hands-free faucets at kitchen handwashing stations'"
                              style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <div class="description">
                            <textarea [readonly]="descriptionChecked"
                              placeholder="Enter Existing Restaurant Description" class="textarea" [ngStyle]="{
                                'margin-bottom':
                                  addGrsForm.get('description')?.touched &&
                                  addGrsForm
                                    .get('description')
                                    ?.hasError('required')
                                    ? '0px'
                                    : '30px',
                                'background-color': descriptionChecked
                                  ? '#F2F5F8'
                                  : 'transparent',
                              }" style="height: 120px" matInput name="description" formControlName="description"
                              required (paste)="onPasteCleanup('description')"></textarea>

                            <mat-error *ngIf="
                                addGrsForm.get('description').touched &&
                                addGrsForm
                                  .get('description')
                                  .hasError('required')
                              ">
                              Description is required
                            </mat-error>
                          </div>

                          <!-- <mat-form-field>
                           
                          </mat-form-field> -->
                        </div>

                        <div style="margin-top: 20px">
                          <button (click)="previousStep()" matButton matStepperPrevious style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;

                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                          </button>
                          <button matButton (click)="nextStep()" matStepperNext style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;

                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            Next<img src="/assets/images/rightarrow.svg" alt="arrow" style="margin-left: 5px" />
                          </button>
                        </div>
                      </div>
                    </mat-step>

                    <mat-step [stepControl]="step3Group">
                      <ng-template matStepLabel>Notes and Media</ng-template>
                      <div class="col-9" style="margin: auto">
                        <label for="operationsCategory" style="
                            font-weight: 500;
                            color: #595a6c;
                            margin-bottom: 3px;
                          ">Details*
                          <span
                            matTooltip="Provide a detailed overview on HOW to meet the standard. Include context - why required, benefits/risks, cost implications, procedures, prerequisites, next steps/actions and key contacts. "
                            style="
                              background-image: url(&quot;/assets/images/Vector.svg&quot;);
                              background-repeat: no-repeat;
                              background-size: auto;
                              background-position: center;

                              padding: 10px;
                            "></span></label>
                        <!-- <mat-label>Notes *</mat-label> -->

                        <quill-editor [ngClass]="{
                            'invalid-note':
                              step3Group.get('note')?.invalid &&
                              step3Group.get('note')?.touched,
                          }" name="note" formControlName="note" class="quill-editor-css"
                          (onEditorCreated)="onEditorCreated($event, 'note')" [preserveWhitespace]="true">
                        </quill-editor>

                        <mat-error *ngIf="
                            addGrsForm.get('note').touched &&
                            addGrsForm.get('note').hasError('required')
                          " style="font-size: x-small">
                          Details required
                        </mat-error>

                        <!-- <mat-label style="margin-top: 20px"
                          >Additional Information *</mat-label
                        > -->
                        <div style="margin-top: 20px">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Additional Information
                            <span matTooltip="Add additional details if neccessary " style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <quill-editor name="additionalInformation" formControlName="additionalInformation"
                            class="quill-editor-css" (onEditorCreated)="
                              onEditorCreated($event, 'additionalInformation')
                            " [preserveWhitespace]="true">
                          </quill-editor>
                        </div>

                        <div>
                          <div>
                            <div style="margin-top: 30px">
                              <label for="operationsCategory" style="
                                  font-weight: 500;
                                  color: #595a6c;
                                  margin-bottom: 3px;
                                ">Resources and Supportive Information
                                <span
                                  matTooltip="Please provide a URL link to any resources/guides/supporting documents housed on SharePoint or OneDrive. Please ensure that permissions are configured appropriately, ensuring users have access. "
                                  style="
                                    background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                    background-repeat: no-repeat;
                                    background-size: auto;
                                    background-position: center;

                                    padding: 10px;
                                  "></span></label>
                            </div>
                            <div formArrayName="resourceLinks1">
                              <div *ngFor="
                                  let link of resourceLinks1.controls;
                                  let i = index
                                " [formGroupName]="i" class="resourceBlock" [ngStyle]="{
                                  'margin-bottom':
                                    addGrsForm.get('linksFieldValid')
                                      ?.touched ||
                                    addGrsForm.get('linksFieldValid')?.invalid
                                      ? '20px'
                                      : '20px',
                                }">
                                <div style="position: relative; flex: 1" class="resourceLinkInValid" [ngClass]="{
                                    invalidborder:
                                      link.get('url')?.value == '' &&
                                      link.get('title')?.value,
                                  }">
                                  <input type="text" formControlName="url" (paste)="onPasteLink($event, link)"
                                    placeholder="Paste Link here..." class="resource-input"
                                    (keydown)="disableTyping($event)" />

                                  <img *ngIf="link.get('url')?.value === ''" alt="mail" (click)="pasteLink(link)"
                                    src="/assets/images/Group (1).svg" style="
                                      position: absolute;
                                      right: 10px;
                                      top: 50%;
                                      transform: translateY(-50%);
                                      width: 18px;
                                      height: 18px;
                                      cursor: pointer;
                                    " />
                                  <svg (click)="openLink(link.get('url')?.value)" *ngIf="link.get('url')?.value !== ''"
                                    xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-box-arrow-up-right link-svg" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                    <path fill-rule="evenodd"
                                      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                  </svg>
                                  <div style="position: absolute">
                                    <mat-error *ngIf="
                                        link.get('title')?.value &&
                                        link.get('url')?.value === ''
                                      " style="font-size: x-small">
                                      Url is required, if title is provided.
                                    </mat-error>
                                  </div>
                                </div>

                                <div style="position: relative; flex: 2" class="resourceTitleInValid" [ngClass]="{
                                    invalidborder:
                                      link.get('title')?.value == '' &&
                                      link.get('url')?.value,
                                  }">
                                  <input [disabled]="link.get('url').value == ''" (input)="onEnterResourceTitle(link)"
                                    type="text" formControlName="title" placeholder="Enter Title"
                                    class="resource-input resource-description" />
                                  <img (click)="removeLink(i)" alt="link" src="/assets/images/Right Link.svg" style="
                                      position: absolute;
                                      right: 10px;
                                      top: 50%;
                                      transform: translateY(-50%);
                                      width: 30px;
                                      height: 30px;
                                      cursor: pointer;
                                    " />
                                  <div style="position: absolute">
                                    <mat-error *ngIf="
                                        link.get('url')?.value &&
                                        link.get('title')?.value === ''
                                      " style="font-size: x-small">
                                      Title is required, if URL is provided.
                                    </mat-error>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <button style="
                                border: 1px solid #ced2ed;
                                padding: 6px 10px 6px 10px;
                                background-color: #f1f3fb;
                                color: #5a69bf;
                                border-radius: 6px;
                                font-weight: 500;
                                margin-bottom: 24px;
                              " type="button" class="add-link-btn" (click)="addLinks()">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                              </svg>
                              Add Another Link
                            </button>
                          </div>
                        </div>

                        <!-- <div
                          style="
                            border: 1px solid black;
                            border-radius: 5px;
                            border-style: dashed;
                            background-color: #f2f5f8;
                            margin-top: 20px;
                            cursor: pointer;
                            margin-bottom: 20px;
                          "
                          class="mcd-upload-images"
                          *ngIf="
                            addGrsForm['controls'].standardTypeId.value ==
                              standardTypeEnum.OperationsStandards ||
                            selectedStandardType == 'Operations Standards'
                          "
                        >
                          <div
                            class="row attachements"
                            (click)="operationsImage.click()"
                          >
                            <div
                              class="col-12"
                              style="text-align: center; padding: 10px"
                            >
                              <div style="margin: auto">
                                <p
                                  style="
                                    color: #3f51b5;
                                    font-size: 20px;
                                    margin: 0;
                                  "
                                >
                                  Choose Files
                                </p>
                                <p style="margin: 0">
                                  *Only JPEG, PNG, & BMP Files Allowed
                                </p>
                              </div>

                              <mat-label
                                *ngIf="grs.standard.imageAttachment?.fileName"
                                >Image File*</mat-label
                              >
                              <div class="uploaded-file">
                                <span class="file-name">
                                  <a
                                    href="javascript:void(0);"
                                    (click)="
                                      onDownloadSelectedImage(
                                        grs.standard.imageAttachment?.id
                                      )
                                    "
                                    >{{
                                      grs.standard.imageAttachment?.fileName
                                    }}</a
                                  >
                                </span>
                                <span
                                  *ngIf="grs.standard.imageAttachment?.fileName"
                                >
                                  <a
                                    href="javascript:void(0);"
                                    (click)="onRemoveImage()"
                                  >
                                    <i class="material-icons delete-icon">
                                      cancel
                                    </i>
                                  </a>
                                </span>
                              </div>
                              <input
                                hidden
                                type="file"
                                (change)="onSelectImage($event)"
                                #operationsImage
                              />
                              <mat-error
                                class="mat-error-left-label"
                                *ngIf="invalidImage"
                              >
                                Invalid file type.
                              </mat-error>
                              <mat-error
                                class="mat-error-left-label"
                                *ngIf="invalidImageRes"
                              >
                                Invalid image resolution.
                              </mat-error>
                            </div>
                          </div>
                        </div> -->

                        <div style="margin-top: 20px">
                          <button (click)="previousStep()" matButton matStepperPrevious style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;

                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                          </button>
                          <button (click)="nextStep()" matButton matStepperNext style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;

                              border: 1px solid #c1c6cd;

                              background-color: #ffffff;
                            ">
                            Next<img src="/assets/images/rightarrow.svg" alt="arrow" style="margin-left: 5px" />
                          </button>

                          <!-- <button
                            matButton
                            matStepperNext
                            [ngStyle]="{
                              color: addGrsForm.invalid ? '#888888' : 'black',
                              cursor: addGrsForm.invalid
                                ? 'not-allowed'
                                : 'pointer',
                              backgroundColor: addGrsForm.invalid
                                ? '#e0e0e0'
                                : '#ffbc0f',
                              borderColor: '#c1c6cd',
                              fontWeight: 'bold',
                              float: 'right',
                              padding: '4px 16px',
                              borderRadius: '5px',
                              border: 'none'
                            }"
                          >
                            Review<img
                              src="/assets/images/rightarrow.svg"
                              alt="arrow"
                              style="margin-left: 5px"
                            />
                          </button> -->
                        </div>
                      </div>
                    </mat-step>

                    <mat-step [stepControl]="step4Group">
                      <form [formGroup]="addGrsForm">
                        <ng-template matStepLabel>Key Contacts</ng-template>

                        <div class="col-9" style="margin: auto">
                          <div>
                            <label style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Key Contacts
                              <span matTooltip="Please share an email address for users who may have questions " style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <div style="display: flex; position: relative">
                              <div class="mail newForm" style="width: 100%">
                                <div class="title">
                                  <input [ngStyle]="{
                                      'margin-bottom':
                                        addGrsForm.get('keyContact')?.touched &&
                                        addGrsForm
                                          .get('keyContact')
                                          ?.hasError('email')
                                          ? '0px'
                                          : '20px',
                                    }" name="keyContact" formControlName="keyContact" placeholder="user@domain.com "
                                    (paste)="onPasteCleanup('keyContact')" class="key-contact" />
                                </div>
                              </div>
                              <div style="
                                  position: absolute;
                                  right: 10px;

                                  padding: 11px 11px 8px 18px;
                                  border-left: 1.5px solid #c1c6cd;
                                ">
                                <img alt="mail" src="/assets/images/mail.svg" />
                              </div>
                            </div>

                            <mat-error style="font-size: x-small; margin-bottom: 20px" *ngIf="
                                addGrsForm.get('keyContact')?.touched &&
                                addGrsForm.get('keyContact')?.hasError('email')
                              ">
                              Please enter a valid email address
                            </mat-error>
                          </div>

                          <div class="newForm">
                            <label style="
                                font-weight: 500;
                                color: #595a6c;

                                margin-bottom: 3px;
                              ">Global Approved Hardware/Equipment
                              <span
                                matTooltip="Provide links to any Globally Approved Hardware or Equipment that enable restaurants to meet the Global Minimum Standard "
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <div class="description">
                              <textarea class="textarea" placeholder="Enter Description" [ngStyle]="{
                                  'margin-bottom':
                                    addGrsForm.get('keyContactDesc')?.touched &&
                                    addGrsForm
                                      .get('keyContactDesc')
                                      ?.hasError('required')
                                      ? '0px'
                                      : '30px',
                                }" style="height: 120px" matInput name="keyContactDesc"
                                formControlName="keyContactDesc" (paste)="onPasteCleanup('keyContactDesc')"></textarea>
                            </div>
                            <!-- <mat-form-field >
                         
                        </mat-form-field> -->
                          </div>

                          <div style="margin-top: 20px">
                            <button (click)="previousStep()" matButton matStepperPrevious style="
                                width: 100px;
                                height: 39px;
                                color: #4d5258;
                                font-weight: 500;
                                border-radius: 5px;
                                border: 1px solid #c1c6cd;

                                background-color: #ffffff;
                                margin-right: 10px;
                              ">
                              <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                            </button>
                            <button disabled matButton matStepperNext style="
                                width: 100px;
                                height: 39px;

                                font-weight: 500;
                                border-radius: 5px;
                                color: #d2d3d5;
                                border: 1px solid #e0e2e6;

                                background-color: #ffffff;
                              ">
                              Next<img src="/assets/images/arrow-right 1.svg" alt="arrow" style="margin-left: 5px" />
                            </button>

                            <button (click)="nextStep()" matButton [disabled]="step3Group.invalid" matStepperNext
                              [ngStyle]="{
                                color: step4Group.invalid ? '#888888' : 'black',
                                cursor: step4Group.invalid
                                  ? 'not-allowed'
                                  : 'pointer',
                                backgroundColor: step4Group.invalid
                                  ? '#e0e0e0'
                                  : '#ffbc0f',
                                borderColor: '#c1c6cd',
                                fontWeight: 'bold',
                                float: 'right',
                                width: '100px',
                                height: '39px',

                                borderRadius: '5px',
                                border: 'none',
                              }">
                              Review
                            </button>
                          </div>
                        </div>
                      </form>
                    </mat-step>

                    <mat-step [completed]="isSuccessfull" class="col-12">
                      <ng-template matStepLabel>Preview</ng-template>
                      <div style="padding: 12px">
                        <div class="review-page-container">
                          <!-- <div class="header"> -->
                          <!-- <div class="stamp">{{ data.stampText }}</div> -->
                          <!-- </div> -->

                          <div [ngClass]="
                              selectedStandardType ===
                              'Global Approved Solution'
                                ? 'global-approved-info-main'
                                : 'info-main'
                            ">
                            <div style="
                                display: flex;
                                justify-content: space-between;
                              ">
                              <h1 class="lastpage-title" style="padding: 10px">
                                {{ addGrsForm.get("title")?.value }}
                              </h1>
                              <img *ngIf="
                                  selectedStandardType ==
                                  'Global Building Standards'
                                " src="../../assets/images/global-minium-badge.svg" />
                              <img *ngIf="
                                  selectedStandardType ==
                                  'Global Approved Solution'
                                " src="../../assets/images/global-app.svg" />
                            </div>
                            <div [ngClass]="
                                selectedStandardType ===
                                'Global Approved Solution'
                                  ? 'global-approved-info-section'
                                  : 'info-section'
                              ">
                              <div class="info-column left-column">
                                <div class="info-row">
                                  <span class="reviewPage-icon date"></span>
                                  <span class="label left-label">New Restaurant Effective Date</span>
                                  <span class="value">{{
                                    addGrsForm.get("newRestaurantEffectiveFrom")
                                    ?.value | date: "dd, MMM yyyy"
                                    }}</span>
                                </div>

                                <div class="info-row">
                                  <span class="reviewPage-icon date2"></span>
                                  <span class="label left-label">Existing Restaurant Effective Date</span>
                                  <span class="value">{{
                                    addGrsForm.get("effectiveFrom")?.value
                                    | date: "dd, MMM yyyy"
                                    }}</span>
                                </div>

                                <div class="info-row">
                                  <span class="reviewPage-icon standardType"></span>
                                  <span class="label left-label">Standard Type</span>
                                  <span class="value">{{
                                    selectedStandardType
                                    }}</span>
                                </div>

                                <div class="info-row">
                                  <span class="reviewPage-icon createdOn"></span>
                                  <span class="label left-label">Created On</span>
                                  <span class="value">{{
                                    createdOn | date: "dd, MMM yyyy"
                                    }}</span>
                                </div>

                                <!-- 
                              <div class="info-row">
                                <span class="icon clock-icon"></span>
                                <span class="label">Last Modified</span>
                                <span class="value">{{
                                  data.lastModified
                                }}</span>
                              </div> -->
                              </div>

                              <div class="divider"></div>

                              <div class="info-column right-column">
                                <div class="info-row">
                                  <span class="reviewPage-icon category"></span>
                                  <span class="label right-label">Category</span>
                                  <span class="value" *ngIf="
                                      selectedStandardType ===
                                        'Global Approved Solution' ||
                                      selectedStandardType === 'BU Standards'
                                    ">{{ dependentcategories }}</span>
                                  <span class="value" *ngIf="
                                      selectedStandardType !=
                                        'Global Approved Solution' &&
                                      selectedStandardType != 'BU Standards'
                                    ">{{ categoryForLastPage }}</span>
                                </div>
                                <div class="info-row">
                                  <span class="reviewPage-icon location"></span>
                                  <span class="label right-label">Location</span>
                                  <span class="value">{{
                                    selectedLocationNames != ""
                                    ? selectedLocationNames
                                    : dependentLocations
                                    }}</span>
                                </div>

                                <div class="info-row">
                                  <span class="reviewPage-icon Sublocation"></span>
                                  <span class="label right-label">Sub Location</span>
                                  <span class="value">{{
                                    subLocationselected != ""
                                    ? lastPageSublocation
                                    : "--"
                                    }}</span>
                                </div>

                                <div class="info-row">
                                  <span class="reviewPage-icon keyContact"></span>
                                  <span class="label right-label">Key Contact</span>
                                  <span class="value">{{
                                    addGrsForm.get("keyContact")?.value != ""
                                    ? addGrsForm.get("keyContact")?.value
                                    : "--"
                                    }}</span>
                                </div>

                                <!-- <div class="info-row">
                                <span class="icon user-icon"></span>
                                <span class="label">Key Contact</span>
                                <span class="value">{{ data.keyContact }}</span>
                              </div> -->
                              </div>
                            </div>
                          </div>

                          <div class="description-section">
                            <div style="
                                display: flex;
                                align-items: center;
                                align-content: center;
                              ">
                              <h2 class="section-title">
                                Description for New Restaurant
                              </h2>
                              <button class="copyIcon">
                                <img (click)="
                                    copyText(
                                      addGrsForm.get('newrestaurantdescription')
                                        .value
                                    );
                                    $event.stopPropagation()
                                  " src="../../assets/images/copy text.svg" alt="" />
                              </button>
                            </div>
                            <p class="description-text">
                              {{
                              addGrsForm.get("newrestaurantdescription")
                              ?.value
                              }}
                            </p>
                          </div>

                          <div class="description-section">
                            <div style="
                                display: flex;
                                align-items: center;
                                align-content: center;
                              ">
                              <h2 class="section-title">
                                Description for Existing Restaurant
                              </h2>
                              <button class="copyIcon">
                                <img (click)="
                                    copyText(
                                      addGrsForm.get('description').value
                                    );
                                    $event.stopPropagation()
                                  " src="../../assets/images/copy text.svg" alt="" />
                              </button>
                            </div>
                            <p class="description-text">
                              {{ addGrsForm.get("description")?.value }}
                            </p>
                          </div>

                          <div class="details-section" style="margin-top: 20px">
                            <div class="details-header" (click)="toggleDetails()">
                              <div class="details-title-wrapper">
                                <div>
                                  <span class="toggle-icon">
                                    <img *ngIf="!detailsExpanded" src="../../assets/images/s-add 1.svg" alt="Expand"
                                      style="margin-bottom: 3px" />

                                    <img *ngIf="detailsExpanded" src="../../assets/images/cross (2).svg" alt="Collapse"
                                      style="margin-bottom: 3px" /></span>
                                  <!-- <span class="details-icon">☑</span> -->
                                  <span class="details-title"> Details </span>
                                </div>
                                <div *ngIf="detailsExpanded">
                                  <img (click)="
                                      copyText(addGrsForm.get('note').value);
                                      $event.stopPropagation()
                                    " src="../../assets/images/copy text.svg" alt="" />
                                </div>
                              </div>
                            </div>

                            <div class="details-content" [class.expanded]="detailsExpanded">
                              <div [innerHTML]="getDetails()" class="detail-section"></div>
                            </div>
                          </div>

                          <div class="details-section" style="margin-top: 20px" *ngIf="
                              addGrsForm.get('additionalInformation').value
                            ">
                            <div class="details-header" (click)="toggleDetails2()">
                              <div class="details-title-wrapper">
                                <div>
                                  <span class="toggle-icon">
                                    <img [ngStyle]="{
                                        display: additionalInfoExpanded
                                          ? 'none'
                                          : '',
                                      }" *ngIf="!additionalInfoExpanded" src="../../assets/images/s-add 1.svg"
                                      alt="Expand" style="margin-bottom: 3px" />
                                    <img [ngStyle]="{
                                        display: !additionalInfoExpanded
                                          ? 'none'
                                          : '',
                                      }" *ngIf="additionalInfoExpanded" src="../../assets/images/cross (2).svg"
                                      alt="Collapse" style="margin-bottom: 3px" /></span>
                                  <!-- <span class="details-icon">☑</span> -->
                                  <span class="details-title">
                                    Additional Info
                                  </span>
                                </div>
                                <div *ngIf="additionalInfoExpanded">
                                  <img (click)="
                                      copyText(
                                        addGrsForm.get('additionalInformation')
                                          .value
                                      );
                                      $event.stopPropagation()
                                    " src="../../assets/images/copy text.svg" alt="" />
                                </div>
                              </div>
                            </div>

                            <div class="details-content" [class.expanded]="additionalInfoExpanded">
                              <div [innerHTML]="getAdditionalInfo()" class="detail-section"></div>
                            </div>
                          </div>

                          <div class="bottom-sections" [class.single-column]="
                              (hasResourceUrls &&
                                !addGrsForm.get('keyContactDesc')?.value) ||
                              (!hasResourceUrls &&
                                addGrsForm.get('keyContactDesc')?.value)
                            ">
                            <div class="resources-section" *ngIf="hasResourceUrls">
                              <div class="section-header">
                                <h2 class="section-heading">
                                  Resources and Supporting Information
                                </h2>
                                <span class="info-icon-circle">?</span>
                              </div>
                              <div class="links-list" formArrayName="resourceLinks1">
                                <a *ngFor="
                                    let resource of resourceLinks1.controls;
                                    let i = index
                                  " [formGroupName]="i" [href]="resource.get('url')?.value" class="resource-link">
                                  {{ resource.get("title")?.value }}
                                </a>
                              </div>
                            </div>

                            <div class="hardware-section" *ngIf="addGrsForm.get('keyContactDesc')?.value">
                              <div class="section-header">
                                <h2 class="section-heading">
                                  Global Approved Hardware/Equipment
                                </h2>
                                <span class="info-icon-circle">?</span>
                              </div>
                              <div class="hardware-content">
                                <span class="hardware-text">
                                  {{ addGrsForm.get("keyContactDesc")?.value }}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="resources-section" style="margin-top: 20px" *ngIf="
                              selectedStandardType ===
                                'Global Approved Solution' ||
                              selectedStandardType === 'BU Standards'
                            ">
                            <div class="section-header">
                              <h2 class="section-heading">
                                Dependent Minimum / Operations Standards
                              </h2>
                              <span class="info-icon-circle">?</span>
                            </div>
                            <div class="links-list">
                              <div class="dmos-cards-grid">
                                <div class="dmos-standard-card" *ngFor="
                                    let item of selectFromDepenedentStandard
                                  ">
                                  <div class="dmos-card-header">
                                    <h3 class="dmos-card-title">
                                      {{ item.title }}
                                    </h3>
                                    <span class="dmos-category-badge dmos-building-site">{{ item.category.name }}</span>
                                  </div>
                                  <div class="dmos-card-body">
                                    <p class="dmos-card-description">
                                      {{ item.description }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="margin-top: 40px">
                          <button matButton (click)="previousStep()" matStepperPrevious style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;

                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                          </button>
                          <button disabled matButton matStepperNext style="
                              width: 100px;
                              height: 39px;

                              font-weight: 500;
                              border-radius: 5px;
                              color: #d2d3d5;
                              border: 1px solid #e0e2e6;

                              background-color: #ffffff;
                            ">
                            Next<img src="/assets/images/arrow-right 1.svg" alt="arrow" style="margin-left: 5px" />
                          </button>

                          <button [disabled]="checkFormValidity()" (click)="saveGrbes()" matButton [ngStyle]="{
                              color: checkFormValidity() ? '#888888' : 'black',
                              cursor: checkFormValidity()
                                ? 'not-allowed'
                                : 'pointer',
                              backgroundColor: checkFormValidity()
                                ? '#e0e0e0'
                                : '#ffbc0f',
                              borderColor: '#c1c6cd',
                              fontWeight: 'bold',
                              float: 'right',
                              width: '100px',
                              height: '39px',

                              borderRadius: '5px',
                              border: 'none',
                            }">
                            Submit
                          </button>
                        </div>
                      </div>
                    </mat-step>
                  </form>
                </mat-stepper>
              </div>
            </div>
          </div>
        </div>

        <!-- <div
            class="mcd-upload-images"
            *ngIf="
              addGrsForm['controls'].standardTypeId.value ==
              standardTypeEnum.OperationsStandards
            "
          >
            <br />
            <div class="row attachements">
              <div class="col">
                <a href="javascript:void(0);" (click)="operationsImage.click()">
                  <span>
                    <img
                      alt="Upload File"
                      src="/assets/images/attachement.svg"
                    />
                  </span>
                  Upload Image (JPEG, PNG, BMP)
                </a>
                <mat-label *ngIf="grs.standard.imageAttachment?.fileName"
                  >Image File</mat-label
                >
                <div class="uploaded-file">
                  <span class="file-name">
                    <a
                      href="javascript:void(0);"
                      (click)="
                        onDownloadSelectedImage(
                          grs.standard.imageAttachment?.id
                        )
                      "
                      >{{ grs.standard.imageAttachment?.fileName }}</a
                    >
                  </span>
                  <span *ngIf="grs.standard.imageAttachment?.fileName">
                    <a href="javascript:void(0);" (click)="onRemoveImage()">
                      <i class="material-icons delete-icon"> cancel </i>
                    </a>
                  </span>
                </div>
                <input
                  hidden
                  type="file"
                  (change)="onSelectImage($event)"
                  #operationsImage
                />
                <mat-error class="mat-error-left-label" *ngIf="invalidImage">
                  Invalid file type.
                </mat-error>
                <mat-error class="mat-error-left-label" *ngIf="invalidImageRes">
                  Invalid image resolution.
                </mat-error>
              </div>
            </div>
          </div> -->
      </div>
    </mat-card-content>
    <!-- <mat-card-footer class="mcd-card-footer">
      <button
        class="mcd-btn mcd-btn-primary"
        *ngIf="!grs.standard.id"
        mat-raised-button
        (click)="reset()"
      >
        Reset
      </button>
      <button
        class="mcd-btn mcd-btn-primary"
        *ngIf="grs.standard.id > 0"
        mat-raised-button
        (click)="onBackClickorEditRedirect()"
      >
        Back
      </button>
      <button
        class="mcd-btn mcd-btn-secondary"
        mat-raised-button
        [disabled]="addGrsForm.invalid"
        (click)="saveGrbes()"
      >
        {{ grs.standard.id > 0 ? "Update" : "Add" }}
      </button>
    </mat-card-footer> -->
  </div>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>